import { StoreManager, CommonRootState } from '../../../store/typings';
import { reset } from '../actions';

let store: StoreManager;

interface LanguageChangeService {
    notifyLanguageChange: (iframe: HTMLIFrameElement, featureId: string) => void;
}

const languageChangeService: LanguageChangeService = {
    notifyLanguageChange(iframe: HTMLIFrameElement, featureId: string) {
        const lang = (store.getState() as CommonRootState).session.language;
        iframe.contentWindow.postMessage({ lang, action: 'language:changed' }, '*');
        store.dispatch(reset(featureId));
    },
};

export const initializeLanguageChangeService = (appStore: StoreManager) => {
    store = appStore;
};

export default languageChangeService;
